import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Component from 'decorators/Component'
import { colors, marginSizes } from 'theme/default'
import Div from 'components/Div'
import Card from 'components/Card'
import { H4, P } from 'components/Typo'
import Checkbox from 'components/Checkbox'

const StyledCard = styled(Card).attrs(() => ({
  marginBottom: 'small'
}))`
  border-color: ${props => props.checked ? props.theme.buttonColor : props.theme.colorLinesAndBorders};
  ${props => props.disabled ? 'opacity: 0.5;' : ''};
`
StyledCard.defaultProps = {
  theme: {
    buttonColor: colors.brandPrimary,
    colorLinesAndBorders: colors.separator
  }
}

const NonPromoCodePromotion = Component()(({
  t,
  promotions = [],
  selectedPromotions = [],
  onPromotionSelect = x => x
}) => {
  const unstackable = selectedPromotions.find((p) => p.stackableOption)
  return (
    <React.Fragment>
      <H4 normalised marginBottom={marginSizes.small} bold>{t('Eligible Promotions')}</H4>
      {promotions.map((promotion, idx) => {
        const checked = selectedPromotions.findIndex((selectedPromo) => selectedPromo.id === promotion.id) > -1
        const disabled = (unstackable && unstackable.id !== promotion.id) || (selectedPromotions.length > 0 && promotion.stackableOption && !checked)
        return (
          <StyledCard
            key={promotion.id}
            disabled={disabled}
            checked={checked}>
            <Checkbox
              name={promotion.id}
              disabled={disabled}
              checked={checked}
              onChange={() => onPromotionSelect(promotion)}
              controlled>
              {({ checked, disabled }) => (
                <React.Fragment>
                  <Checkbox.Tick data-testid={`checkbox.tick.${idx}`} checked={checked} disabled={disabled} />
                  <Div>
                    <P bold normalised>{promotion.name}</P>
                    <P normalised>{promotion.description}</P>
                  </Div>
                </React.Fragment>
              )}
            </Checkbox>
          </StyledCard>
        )
      })}
    </React.Fragment>
  )
})

NonPromoCodePromotion.propTypes = {
  promotions: PropTypes.array.isRequired,
  selectedPromotions: PropTypes.array.isRequired,
  onPromotionSelect: PropTypes.func.isRequired
}

export default NonPromoCodePromotion
